export enum FiatAccountType {
  ach = 'ACH',
  swift = 'SWIFT',
  sepa = 'SEPA',
  wire = 'WIRE',
  pix = 'PIX',
  cop = 'COP',
  spei = 'SPEI',
  cvu = 'CVU',
  crypto = 'CRYPTO',
  unset = '',
}
